import { useContext, useEffect, useState } from 'react'

// others
import { Case, CaseStatus, OrderCaseBy, useFetchAllMattersWithoutJoinLazyQuery } from '../../generated'
import { AppContext, CaseContext } from '../context'
import { ActionType } from '../context/AppContextReducer'

// components
import { CaseActionType } from '../components/cases/caseReducer'
import { Alert } from '../components/common/Alert'
import { GRAPHQL_QUERY_POLICY_CACHE_FIRST } from '../constants'

export const useCases = ({
  fetchCasesOfUser,
  searchValue,
  skipFetch = false
}: {
  fetchCasesOfUser?: string
  searchValue?: string
  /** When true, do not fetch (e.g. entry modal with preselected case uses dropdown as single fetcher) */
  skipFetch?: boolean
}) => {
  const [cases, setCases] = useState<Case[]>([])
  const { currentPage, pageLimit, dispatch: reducerDispatch } = useContext(AppContext)
  const { dispatch } = useContext(CaseContext)

  const [fetchCases] = useFetchAllMattersWithoutJoinLazyQuery({
    ...GRAPHQL_QUERY_POLICY_CACHE_FIRST,
    variables: undefined,

    onError() {
      setCases([])
      reducerDispatch({ type: ActionType.SET_IS_LOADING, isLoading: false })
    },

    onCompleted(data) {
      if (data) {
        const { fetchAllMattersWithoutJoin: fetchAllCases } = data

        if (fetchAllCases) {
          const { cases } = fetchAllCases

          if (cases) {
            setCases(cases as Case[])
            dispatch({ type: CaseActionType.SET_ALL_CASES, allCases: cases })
          } else Alert.warning('No matters for this user')
        }
      }
    }
  })

  useEffect(() => {
    if (skipFetch) return
    const hasUser = !!fetchCasesOfUser?.trim()
    const hasSearch = !!searchValue?.trim()
    if (!hasUser && !hasSearch) return

    fetchCases({
      variables: {
        casesInput: {
          userId: fetchCasesOfUser,
          orderBy: OrderCaseBy.MatterNo,
          status: CaseStatus.Active,
          isConsultCase: undefined,
          searchValue: searchValue || undefined,
          paginationOptions: {
            limit: pageLimit,
            page: currentPage
          }
        }
      }
    })
  }, [currentPage, fetchCases, fetchCasesOfUser, pageLimit, searchValue, skipFetch])

  return { cases }
}
